import { useEffect, useRef } from "react";
import Lightbox from "photoswipe/lightbox";
import "photoswipe/style.css";
import projectImages from "./ProjectImages";
import "./GalerySection.css";
import { HiOutlineZoomIn } from "react-icons/hi";
import { arrowLeftSVG, closeSVG, zoomSVG } from "./photoswipeIcons";
import SectionTitle from "../common/SectionTitle";

const GalerySection = () => {
  const sectionRef = useRef(null);

  /* photoSwipe */
  useEffect(() => {
    const galleryEl = sectionRef.current;
    if (!galleryEl) return;

    let lightbox = null;
    let initialized = false;

    const init = () => {
      if (initialized) return;
      initialized = true;

      lightbox = new Lightbox({
        gallery: "#my-gallery",
        children: "a",
        pswpModule: () => import("photoswipe"),
        //animace otevření
        showHideAnimationType: "fade",
        //vlastní ikony
        arrowPrevSVG: arrowLeftSVG,
        arrowNextSVG: arrowLeftSVG,
        closeSVG: closeSVG,
        zoomSVG: zoomSVG,
        mainClass: "pswp--custom-icon-colors",
      });

      lightbox.init();
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          init();
          observer.disconnect();
        }
      },
      { root: null, rootMargin: "200px", threshold: 0.01 }
    );

    observer.observe(galleryEl);

    return () => {
      observer.disconnect();
      if (lightbox) {
        lightbox.destroy();
        lightbox = null;
      }
      initialized = false;
    };
  }, []);

  return (
    <section id="galery" ref={sectionRef} className="galery-section">
      <div className="galery-wrapper">
        <SectionTitle title="projekty" />
        <h2 className="galery-subtitle">Stavby a rekonstrukce</h2>

        {/* grid fotek */}
        <div id="my-gallery" className="gallery">
          {projectImages.map(({ src, width, height }, index) => {
            return (
              <a
                href={src}
                key={src}
                data-pswp-width={width}
                data-pswp-height={height}
                className={`gallery-item ${
                  index === 0 ? "visible-on-mobile" : ""
                }`}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={src}
                  alt={`Projekt ${index + 1}`}
                  className="gallery-image"
                  loading={index === 0 ? "eager" : "lazy"}
                  decoding="async"
                  fetchPriority={index === 0 ? "high" : "auto"}
                />
                {/* overlay */}
                <div className="gallery-overlay">
                  <span className="gallery-icon">
                    <HiOutlineZoomIn />
                  </span>
                  <span className="gallery-text">Zobrazit galerii</span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default GalerySection;
